import styled from 'styled-components';
import { DEFAULT_PORTAL_ID } from '@mews-commander/constants';
import { isMobile, WithBreakpointRange } from '@mews-commander/ui';
import { Sidebar, SidebarDefaultedProps, withBreakpointRange } from '@optimus-web/core';
import { BackdropElement, SidebarElement } from '@optimus-web/core/src/Sidebar/style';
import { Portal } from '@optimus-web/helpers';
import { HEIGHT_APP_NAV_BAR, Z_INDEX_SIDEBAR } from '../commander-ui/constants';

export interface CommanderSidebarProps extends SidebarDefaultedProps {
    fullScreen?: boolean;
    modalIndex?: number;
    zIndex?: number;
}

type CommanderSidebarComponentProps = CommanderSidebarProps & WithBreakpointRange;

const CommanderSidebarElement = styled(Sidebar)<CommanderSidebarProps & WithBreakpointRange>`
    left: -60px;
    ${({ zIndex }) =>
        zIndex &&
        `
        z-index: ${zIndex};
    `}

    ${({ absolute }) =>
        absolute &&
        `
        position: absolute;
    `}

    ${({ modalIndex }) =>
        modalIndex &&
        `
        left: -${60 + (modalIndex - 1) * 10}px;
        z-index: ${modalIndex * 100};
    `}

    ${({ breakpointRange }) =>
        isMobile(breakpointRange) &&
        `
        left: 0;
    `}

    ${BackdropElement} {
        cursor: pointer;
    }

    ${SidebarElement} {
        height: 100%;
        max-height: calc(var(--vh, 1vh) * 100 - ${HEIGHT_APP_NAV_BAR});

        ${({ fullScreen }) =>
            fullScreen &&
            `
            max-height: initial;
        `}

        ${({ width }) =>
            width &&
            `
            width: ${width};
        `}

        ${({ breakpointRange }) =>
            isMobile(breakpointRange) &&
            `
            width: 100%;
        `}
    }
`;

const CommanderSidebar = ({
    children,
    closeOnBackdropClick = true,
    fullScreen,
    width = '440px',
    zIndex = Z_INDEX_SIDEBAR,
    ...other
}: React.PropsWithChildren<CommanderSidebarComponentProps>) => {
    const props = {
        ...other,
        closeOnBackdropClick,
        fullScreen,
        width,
        zIndex,
    };

    if (fullScreen) {
        return (
            <CommanderSidebarElement {...props} absolute>
                {children}
            </CommanderSidebarElement>
        );
    }

    return (
        <Portal containerId={DEFAULT_PORTAL_ID}>
            <CommanderSidebarElement {...props} absolute>
                {children}
            </CommanderSidebarElement>
        </Portal>
    );
};

export default withBreakpointRange(CommanderSidebar);
